import {Component, Inject, Input, OnChanges, SimpleChanges} from "@angular/core";
import {ConsultationSportItemComponent} from "../consultation-sport-item/consultation-sport-item.component";
import {AiRealtimeAppEvent} from "../../../../../../../modules/ai/realtime/api/service/aiRealtime.service";
import {
    MedicalRecordSportConverter
} from "../../../../../../../modules/medical/medical-record/sport/api/converter/medicalRecordSport.converter";
import {
    MedicalRecordSportModel
} from "../../../../../../../modules/medical/medical-record/sport/api/model/medicalRecordSport.model";
import {
    AiAppEventRendererComponent
} from "../../../../../../../modules/ai/realtime/api/component/aiAppEventRenderer.component";

@Component({
    standalone: true,
    imports: [ConsultationSportItemComponent],
    template: `
    <app-luna-consultation-sport-item
      [sport]="sport">
    </app-luna-consultation-sport-item>
  `,
})
export class ConsultationSportAiEventComponent implements AiAppEventRendererComponent, OnChanges {
    static readonly eventName = 'sport';
    sport: MedicalRecordSportModel;

    @Input() event!: AiRealtimeAppEvent;

    constructor(private sportConverter: MedicalRecordSportConverter){
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.sport = this.sportConverter.convert(this.event?.data);
    }


}